import store from './redux/store';
import Dialog from './Dialog.jsx';
import Connections from './Connections.jsx';
import { Provider } from 'react-redux';
import * as UIActions from './redux/actions/ui.actions';
import * as API from './api/client';
import * as SourceCardUtil from './components/availableSources/SourceCardUtil';
import React from 'react';

const HotGlueContext = React.createContext(null);
const HotglueProvider = HotGlueContext.Provider;


export const HotglueConfig = ({ config: { envId, apiKey, apiUrl = '', options = {} }, children }) => {

    UIActions.initializeWidget(apiKey, envId, apiUrl, options);


  return (
    <HotglueProvider
      value={{
        link: (tenant, flow, id, preloaded = false, options = {}) =>
          UIActions.link(tenant, flow, id, preloaded, options),
        setListener: (listener) => UIActions.setListener(listener),
        setSchema: (schema, { enforceOneToOneMapping = undefined } = {}) => {
          UIActions.setMappingSchema(schema);
          enforceOneToOneMapping !== undefined && UIActions.setEnforceOneToOneMapping(enforceOneToOneMapping);
        },
        setMetadata: (metadata) => UIActions.setMetadata(metadata),
        reconnect: (tenant, flow, entityId, options) => UIActions.reconnect(tenant, flow, entityId, options),
        disconnect: (tenant, flow, entityId, options) => UIActions.disconnect(tenant, flow, entityId, options),
        runJob: (entityId, flow, tenant, startDate, jobType) => API.createJob(entityId, flow, tenant, startDate, jobType),
        createJob: (flow, tenant, startDate) => API.createJob(undefined, flow, tenant, startDate),
        pollJob: (jobRoot, flow, tenant) => SourceCardUtil.pollJob(jobRoot, flow, tenant),
        getLinkedSources: (flow, tenant) => API.getLinkedSources(undefined, false, flow, tenant),
        getLinkedConnectors: (flow, tenant) => API.getLinkedConnectors(undefined, undefined, flow, tenant),
        getLinkedTargets: (flow, tenant) => API.getLinkedTargets(undefined, flow, tenant),
        getAvailableSources: () => API.getAvailableSources(),
        getAvailableConnectors: () => API.getAvailableConnectors(),
        getAvailableTargets: () => API.getAvailableTargets(),
        getLinkedFlows: (tenant) => API.getLinkedFlows(tenant),
        getSupportedSources: (flow) => API.getSupportedSources(flow),
        getSupportedTargets: (flow) => API.getSupportedTargets(flow),
        getSupportedConnectors: (flow) => API.getSupportedConnectors(flow),
        setOptions: (options = {}) => UIActions.handleOptions(options),
        openWidget: (tenant, options) => {
          UIActions.openWidget(tenant);
          UIActions.handleOptions(options);
        },
        close: () => UIActions.closeWidget(),
      }}
    >
      <Provider store={store}>
        <Dialog />
        {children}
      </Provider>
    </HotglueProvider>
  );
};

export const useHotglue = () => {
  const context = React.useContext(HotGlueContext);

  if (!context) {
    throw new Error('useHotglue must be used within a HotglueConfig');
  }

  return context;
};

export { Connections };


export default HotglueConfig;
